import { render, staticRenderFns } from "./IndexHeader.vue?vue&type=template&id=0da5d4c9&scoped=true&"
import script from "./IndexHeader.vue?vue&type=script&lang=js&"
export * from "./IndexHeader.vue?vue&type=script&lang=js&"
import style0 from "./IndexHeader.vue?vue&type=style&index=0&id=0da5d4c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5d4c9",
  null
  
)

export default component.exports